import { render, staticRenderFns } from "./agentur-popover.vue?vue&type=template&id=1a4870a0&scoped=true"
import script from "./agentur-popover.vue?vue&type=script&lang=js"
export * from "./agentur-popover.vue?vue&type=script&lang=js"
import style0 from "./agentur-popover.vue?vue&type=style&index=0&id=1a4870a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4870a0",
  null
  
)

export default component.exports